<mat-toolbar [class.campo-encontrado]="campos.includes('archivos')">
    <span>Agregar Archivos</span>
    <span class="spacer"></span>
</mat-toolbar>
<div class="p-5 bg-white w-full">
    <form [formGroup]="formArchivos">
        <div class="flex flex-col pl-5 pr-5">
            @for (archivo of archivos; track archivo) {
                <div class="flex justify-start items-center pb-2">
                    <a mat-mini-fab color="primary" href="{{ archivo.url }}" target="_blank" disabled="{{archivo.url?false:true}}">
                        <mat-icon>remove_red_eye</mat-icon>
                    </a>
                    <button mat-mini-fab color="warn" class="ml-2 mr-2" (click)="deleteFile(archivo)" [disabled]="deshabilitado">
                        <mat-icon>delete</mat-icon>
                    </button>
                    <span>{{ archivo.name }} <b class="text-xs">{{archivo.code}}</b></span>
                </div>
            }
        </div>
        <div class="flex p-5 pb-0 flex-row">
            <button mat-flat-button color="primary" (click)="inputFile.click()" [disabled]="deshabilitado">AGREGAR ARCHIVO</button>
            <input #inputFile type="file" multiple="false" (change)="selectFile($event)" class="hidden"/>
        </div>
    </form>
</div>